import React from 'react'
import { LazyImage } from 'components/image';

const eventHomePrev = `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/landing/h8lvm6geh3mdpdqxdo8i`

function Index() {
    return (
        <div className="flex items-center justify-center mt-0 h-fit md:h-screen md:mt-20">
            <div className="w-[90%] mx-auto">
                <div className="flex flex-col items-center text-black">
                    {/* Responsive Text Size */}
                    <div className='text-2xl sm:text-3xl md:text-[40px] mt-20 text-center'>Couple Squad <span className='text-gray-500'> Web </span> and <span className='text-gray-500'>App </span> Versions</div>
                    <div className='text-sm sm:text-md md:text-lg text-gray-500 w-[90%] md:w-[67%] text-center mt-6 mb-5'>
                        Get the best of both with Couple Squad! Whether you prefer browsing on your computer or swiping on your phone, we've made sure to have a place for everyone in our community.
                    </div>

                    {/* Image and Arrows Section */}
                    <div className='flex items-center justify-center gap-2 mt-5 mb-0 sm:mb-20 lg:gap-5'>
                        <LazyImage src={eventHomePrev} alt="Desktop and Mobile" className='w-[290px] md:w-full' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Index